import React from 'react'

import styled from 'styled-components'

import { Box, ICONS_NAME, Typography } from '../../'

import { HeaderIcon } from './icon'
import { Color } from '@/utils'

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 50px;
  padding: 0 10px 0 18px;
  background: ${Color.lightGray};
  border-bottom: 1px solid ${Color.lightGrayHover};
  border-radius: 5px;
`


export const ModalHeader = ({
 title,
 enableMaximize,
 isMaximized,
 toggleMaximize,
 toggleModal,
}) => (
    <Header>
        <Typography variant="h6" color={Color.textSecondary}>
            {title}
        </Typography>

        <Box gap="10px">
            {enableMaximize && (
                <HeaderIcon
                    icon={isMaximized ? ICONS_NAME.shrink : ICONS_NAME.maximize}
                    onClick={toggleMaximize}
                />
            )}

            <HeaderIcon icon={ICONS_NAME.close} onClick={toggleModal} />
        </Box>
    </Header>
)
